import React, {useEffect, useState} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import { ButtonNew} from "../../../components/buttons/buttonsActions";
import LegalList from "./_list";
import LegalForm from "./_form";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {showLoader} from "../../../components/loader/loader";

function Legal(props){

    const { loading } = props.mainProps
    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);


    },[]);

    const createItem = () => {
        props.setForm()
        ModalFormContainer(LegalForm, { data: null, Form: LegalForm });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <LegalList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(Legal)
